/**
 * Shown when the app is loading after B2C redirect (/signin-oidc).
 * Keeps the user on this page while SsoAuthHandler processes the redirect and sets auth,
 * then SsoAuthHandler navigates to home. Do not redirect to login from here.
 */
import { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export function SignInCallbackPage() {
  useEffect(() => {
    if (import.meta.env.DEV) console.log('[SignInCallbackPage] mounted (waiting for SsoAuthHandler to set auth and navigate to /)');
  }, []);
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        backgroundColor: 'background.default',
      }}
    >
      <CircularProgress size={48} />
      <Typography variant="body1" color="text.secondary">
        Signing you in...
      </Typography>
    </Box>
  );
}
